<template>
  <div class="en_wrapper">
        <div class="page page1">
          <div class="en_header">
            <h1>創鉅有限合夥交易申請書</h1>
            <div class="nb">
              合約編號：<div class="con-nb"><span></span></div>
            </div>
          </div><!--header-->
          <div class="top">
            <div class="top-car">
              車種：
              <div class="con0">
                <div class="checkDiv">
                      <span class="checkbox checkbox1">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      機車&nbsp;
                </div>
                <div class="checkDiv">
                      <span class="checkbox checkbox2">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      電動車&nbsp;
                </div>
                <div class="checkDiv">
                      <span class="checkbox checkbox3">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                          </label>
                      </span>
                      重機
                </div>
              </div><!--con0-->
            </div><!--top-car-->
            
            <div class="top-nb">
              經銷商統編：<div class="con-top-nb"><span></span></div>
            </div>
            <div class="top-date">
              申請日期：<div class="con-top-date"><span>{{editedItem.applyDate.year}}/{{editedItem.applyDate.month}}/{{editedItem.applyDate.day}}</span></div>
            </div>
          </div><!--top-->
          <div class="area1">
            <div class="en_title">申請資訊</div>
            <table class="table1">
              <tr>
                <td width="245px">
                  <span class="tdTit">申請金額：</span>
                  <div class="con1"><span>{{editedItem.vendor.totalCreditPrice}}</span></div>
                </td>
                <td width="220px">
                  <span class="tdTit">期數：</span>
                  <div class="con2">{{editedItem.vendor.installmentsNumber}}</div>
                  </td>
                <td class="tdEnd">
                  <span class="tdTit">期付款：</span>
                  <div class="con3">{{editedItem.vendor.creditPriceMonth}}</div>
                </td>
              </tr>
            </table>
            <table class="table2">
              <tr class="tr">
                <td colspan="4" class="tdEnd">
                  <span class="tdTit">帳單地址:</span>
                  <div class="con4">
                    <div class="checkDiv">
                      <span class="checkbox checkbox4">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      通訊地
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox5">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      現居地
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox6">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      戶籍&nbsp;
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox7">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      其他&nbsp;
                    </div>
                    <div class="con4-1">{{editedItem.customer.home.residenceAddress}}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td width="55px"><span class="tdTit">行照資料</span></td>
                <td width="135px" class="tdEnd">
                  <span class="tdTit">車號：</span>
                  <div class="con5"></div>
                </td>
                <td width="190px" class="tdEnd">
                  <span class="tdTit">排氣量cc/馬力：</span>
                  <div class="con6"></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">廠牌型式：&nbsp;出廠年月：</span>
                  <div class="con7"></div>
                  <div class="con7-2"></div>
                </td>
              </tr>
            </table>
          </div><!--area1-->
          <div class="area2">
            <div class="en_title">申&nbsp;&nbsp;請&nbsp;&nbsp;人</div>
            <div class="en_title2">個人資料</div>
            <table class="table3">
              <tr>
                <td width="120px">
                  <span class="tdTit">姓名：</span>
                  <div class="con8"><span>{{editedItem.customer.name}}</span></div>
                </td>
                <td width="158px">
                  <span class="tdTit">身分證字號：</span>
                  <div class="con9">{{editedItem.customer.memberId}}</div>
                  </td>
                <td width="178px">
                  <span class="tdTit">身分證換證日期：</span>
                  <div class="con10"></div>
                </td>
                <td width="92px">
                  <div class="con11">
                    <div class="checkDiv">
                      <span class="checkbox checkbox8">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.married[0].value" :src="checkedImage"></label>
                      </span>
                      已婚
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox9">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.customer.married[1].value" :src="checkedImage">
                          </label>
                      </span>
                      未婚
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox10">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      其他
                    </div>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">生日：</span>
                  <div class="con12"><div class="y">{{editedItem.customer.birthdayInfo.year}}</div>/
                  <div class="m">{{editedItem.customer.birthdayInfo.month}}</div>/
                  <div class="d">{{editedItem.customer.birthdayInfo.day}}</div></div>
                </td>
              </tr>
            </table><!--table3-->
            <table class="table4">
              <tr>
                <td width="153px" class="tdEnd">
                  <span class="tdTit">戶籍地址：</span>
                  <div class="con13">
                    <div class="checkDiv">
                      <span class="checkbox checkbox11">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      同身分證住址&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox12">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      其他
                    </div>
                  </div>                 
                </td>
                <td width="395px">
                  <span class="tdTit">電話：</span>
                   <div class="con14">
                    <div class="con14-1">{{editedItem.customer.phone}}</div>
                    <div class="con14-2">{{editedItem.customer.home.residenceAddress}}</div>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">行動電話：</span>
                  <div class="con15">{{editedItem.customer.cellphone}}</div>    
                </td>
              </tr>
            </table><!--table4-->
            <table class="table5">
              <tr>
                <td width="108px" class="tdEnd">
                  <span class="tdTit">通訊地址：</span>
                  <div class="con16">
                    <div class="checkDiv">
                      <span class="checkbox checkbox13">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.customer.home.homeType1[0].value" :src="checkedImage">
                        </label>
                      </span>
                      戶籍
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox14">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.customer.home.homeType1[1].value" :src="checkedImage">
                        </label>
                      </span>
                      其他
                    </div>
                  </div>                 
                </td>
                <td width="440px">
                  <span class="tdTit">電話：</span>
                    <div class="con17">
                      <div class="con17-1">{{editedItem.customer.homePhone}}</div>
                      <div class="con17-2">{{editedItem.customer.home.homeAddress1}}</div>
                    </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">E-mail：</span>
                  <div class="con18">{{editedItem.customer.email}}</div>    
                </td>
              </tr>
            </table><!--table5-->
            <table class="table6">
              <tr>
                <td width="359px">
                  <span class="tdTit tdTit19">現居地住</span>
                  <div class="con19">{{editedItem.customer.home.liveYear}}</div><span class="tdTit tdTit19-2">年</span>  
                  <div class="con20">
                    <div class="checkDiv">
                      <span class="checkbox checkbox15">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.customer.home.liveLevel[0].value" :src="checkedImage">
                        </label>
                      </span>
                      自有\配偶\親人所有
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox16">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.customer.home.liveLevel[3].value" :src="checkedImage">
                        </label>
                      </span>
                      租屋
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox17">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.liveLevel[5].value" :src="checkedImage"></label>
                      </span>
                      其他/朋友/其他親戚/無法判斷
                    </div>
                  </div>
                  <div class="con21"><div class="con21-1"></div></div>      
                </td>
                <td width="189px">
                  <div class="con22">
                    <div class="checkDiv">
                      <span class="checkbox checkbox18">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img src="checked.png"></label>
                      </span>
                      是否有信用卡/銀行名稱
                    </div>
                  </div>
                  <div class="con23">{{editedItem.bank.name}}</div>                 
                </td>
                <td class="tdEnd">
                  <span class="tdTit">學歷：</span>
                  <div class="con24"></div>
                </td>
              </tr>
            </table><!--table6-->
            <table class="table7">
              <tr>
                <td width="264px">
                  <span class="tdTit">聯絡人姓名：</span>
                  <div class="con25">{{editedItem.firstContact.name}}</div>
                </td>
                <td width="189px">
                  <span class="tdTit">聯絡人關係：</span>
                  <div class="con26">{{editedItem.firstContact.type}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">聯絡人電話：</span>
                  <div class="con27">{{editedItem.firstContact.cellphone}}</div>
                </td>
              </tr>
            </table><!--table7-->
            <div class="en_title3">就業資料</div>
            <table class="table8">
              <tr class="tr">
                <td width="48px" rowspan="2" style="border-bottom:0">
                  <div class="con28">
                    <div class="checkDiv">
                      <span class="checkbox checkbox19">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      就業中
                    </div>
                  </div>
                </td>
                <td width="216px">
                  <span class="tdTit">公司名稱：</span>
                  <div class="con29">{{editedItem.company.name}}</div>
                </td>
                <td width="214px">
                  <span class="tdTit">職稱：</span>
                  <div class="con30">{{editedItem.company.title}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit31">公司電話：</span>
                  <div class="con31">(<div class="con31-1"></div>)&nbsp;<div class="con31-2">{{editedItem.company.phone}}</div></div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit tdTit32">年資</span>
                  <div class="con32">{{editedItem.company.workYear}}</div>
                  <span class="tdTit tdTit32-2">年</span>
                </td>
                <td class="tdEnd" colspan="2">
                  <span class="tdTit">月收入：</span>
                  <div class="con33">{{editedItem.company.salary}}</div>
                </td>
              </tr>
            </table><!--table8-->
            <table class="table9">
              <tr class="tr">
                <td width="48px">
                  <div class="con34">
                    <div class="checkDiv">
                      <span class="checkbox checkbox20">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      家管
                    </div>
                  </div>
                </td>
                <td width="150px">
                  <span class="tdTit">配偶姓名：</span>
                  <div class="con35">{{editedItem.firstContact.name}}</div>
                </td>
                <td width="161px">
                  <span class="tdTit">配偶手機：</span>
                  <div class="con36">{{editedItem.firstContact.cellphone}}</div>
                </td>
                <td width="151px">
                  <span class="tdTit tdTit37">配偶公司名稱：</span>
                  <div class="con37"></div>
                </td>
                <td  class="tdEnd">
                  <span class="tdTit tdTit38">配偶公司電話：</span>
                  <div class="con38">(<div class="con38-1"></div>)&nbsp;<div class="con38-2">{{editedItem.firstContact.companyPhone}}</div></div>
                </td>
              </tr>
              <tr class="tr">
                <td>
                  <div class="con39">
                    <div class="checkDiv">
                      <span class="checkbox checkbox21">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      學生
                    </div>
                  </div>
                </td>
                <td colspan="2">
                  <span class="tdTit">學校名稱：</span>
                  <div class="con40"></div>
                </td>
                <td colspan="2"  class="tdEnd">
                  <span class="tdTit">科系：</span>
                  <div class="con41"></div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="con42">
                    <div class="checkDiv">
                      <span class="checkbox checkbox22">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      待業中
                    </div>
                  </div>
                </td>
                <td colspan="4" class="tdEnd">
                  <div class="con43"></div>
                </td>
              </tr>
            </table><!--table9-->
          </div><!--area2-->
          <div class="area3">
            <div class="en_title">連帶保證人</div>
            <table class="table10">
              <tr>
                <td width="148px">
                  <span class="tdTit">姓名：</span>
                  <div class="con44">{{editedItem.jointGuarantor.name}}</div>
                </td>
                <td width="179px">
                  <span class="tdTit">身分證字號：</span>
                  <div class="con45">{{editedItem.jointGuarantor.memberId}}</div>
                </td>
                <td width="104px">
                  <div class="con46">
                    <div class="checkDiv">
                      <span class="checkbox checkbox23">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                          </label>
                      </span>
                      已婚
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox24">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                          </label>
                      </span>
                      未婚
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox25">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      其他
                    </div>
                  </div>
                </td>
                <td width="208px">
                  <span class="tdTit">生日：</span>
                  <div class="con47">
                    <div class="y">{{editedItem.jointGuarantor.birthdayInfo.year}}</div>/
                    <div class="m">{{editedItem.jointGuarantor.birthdayInfo.month}}</div>/
                    <div class="d">{{editedItem.jointGuarantor.birthdayInfo.day}}</div>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">關係：</span>
                  <div class="con48">{{editedItem.jointGuarantor.type}}</div>
                </td>
              </tr>
            </table><!--table10-->
            <table class="table11">
              <tr class="tr">
                <td width="431px">
                  <span class="tdTit">戶籍地址：</span>
                  <div class="con49">
                    <div class="checkDiv">
                      <span class="checkbox checkbox26">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      同身分證住址&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox27">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      其他&nbsp;
                    </div>
                    <div class="con49-1">{{editedItem.jointGuarantor.home.residenceAddress}}</div>
                  </div>
                </td>
                <td width="133px">
                  <span class="tdTit">電話：</span>
                  <div class="con50">{{editedItem.jointGuarantor.homePhone}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">行動電話：</span>
                  <div class="con51">{{editedItem.jointGuarantor.cellphone}}</div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <span class="tdTit">通訊地址：</span>
                  <div class="con52">
                    <div class="checkDiv">
                      <span class="checkbox checkbox28">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      戶籍&nbsp;&nbsp;
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox29">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      公司地&nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox30">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      其他
                    </div>                    
                  </div>
                  <span class="tdTit tdTit53 ">電話：</span>
                  <div class="con53">
                    <div class="con53-1"></div>
                    <div class="con53-2">{{editedItem.jointGuarantor.home.homeAddress2}}</div>
                  </div>
                </td>
                <td class="tdEnd"></td>
              </tr>
            </table><!--table11-->
            <table class="table12">
              <td width="327px">
                <span class="tdTit tdTit54">現居地住</span>
                <div class="con54">{{editedItem.jointGuarantor.home.liveYear}}</div>
                <span class="tdTit tdTit54-2">年</span>
                <div class="con55">
                    <div class="checkDiv">
                      <span class="checkbox checkbox31">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.jointGuarantor.home.liveLevel[0].value" :src="checkedImage"></label>
                      </span>
                      自有\配偶所有
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox32">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.jointGuarantor.home.liveLevel[2].value" :src="checkedImage"></label>
                      </span>
                      父母\子女所有
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox33">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.jointGuarantor.home.liveLevel[3].value" :src="checkedImage"></label>
                      </span>
                      租賃
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox34">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.jointGuarantor.home.liveLevel[5].value" :src="checkedImage"></label>
                      </span>
                      其他
                    </div>
                    <div class="con55-1"></div>
                </div>
              </td>
              <td width="237px">
                <span class="tdTit tdTit56">學歷</span>
                <div class="con56">
                    <div class="checkDiv">
                      <span class="checkbox checkbox35">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      研究所&nbsp;
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox36">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      大學/大專&nbsp;
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox37">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      高中職&nbsp;
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox38">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img src="checked.png"> -->
                        </label>
                      </span>
                      初中及以下
                    </div>
                </div>
              </td>
              <td width="94px">
                <span class="tdTit tdTit57">月收入</span>
                <div class="con57"></div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit58">年資</span>
                <div class="con58">{{editedItem.company.workYear}}</div>
                <span class="tdTit tdTit58-2">年</span>
              </td>
            </table><!--table12-->
            <table class="table13">
              <tr>
                <td width="148px">
                  <span class="tdTit">任職公司：</span>
                  <div class="con59"><div class="con59-1">{{editedItem.jointGuarantor.companyName}}</div></div>
                </td>
                <td width="103px">
                  <span class="tdTit">職稱：</span>
                  <div class="con60"><div class="con60-1">{{editedItem.jointGuarantor.title}}</div></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit61">公司地址：電話：</span>
                  <div class="con61">
                    <div class="con61-1"></div>
                    <div class="con61-2">{{editedItem.jointGuarantor.companyPhone}}</div>
                  </div>
                </td>
              </tr>
            </table><!--table13-->
          </div><!--area3-->
        </div><!--page1-->
        <div class="page page2">
          <h4>中&nbsp;&nbsp;古&nbsp;&nbsp;機&nbsp;&nbsp;車&nbsp;&nbsp;分&nbsp;&nbsp;期&nbsp;&nbsp;付&nbsp;&nbsp;款&nbsp;&nbsp;買&nbsp;&nbsp;賣&nbsp;&nbsp;契&nbsp;&nbsp;約</h4>
          <table class="table1">
            <tr>
              <td width="445px">
                <span class="tdTit">甲方(即出賣人)：&nbsp;&nbsp;創鉅有限合夥乙方&nbsp;(&nbsp;即買受人&nbsp;)：</span>
                <div class="con1">{{editedItem.customer.name}}</div>

              </td>
              <td width="190px">
                <span class="tdTit">標的物車號：</span>
                <div class="con2"></div>
              </td>
              <td>
                <span class="tdTit">廠牌：</span>
                <div class="con3"></div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="tdTit">價金給付方式：&nbsp;總價：新台幣</span>
                <div class="con4">給付方式</div>
                <div class="con5">{{editedItem.vendor.totalCreditPrice}}</div>
                <span class="tdTit5">元整（含稅）</span>
              </td>
              <td>
                <span class="tdTit">排氣量：</span>
                <div class="con6"></div>
              </td>
              <td>
                <span class="tdTit">出廠年月：</span>
                <div class="con7"></div>
              </td>
            </tr>
          </table><!--table1-->
          <p class="p1">
            ⦿指乙方應給付之全部價金，除乙方違約外，甲方不再以其他名義，要求乙方給付額外金額。請依下列方式分期支付之：<br/>
            分期付款之起始月份自甲方撥付甲方先前買受本案標的物價款予乙方之次月起，每月為一期，共分<span class="p1-1">{{editedItem.vendor.installmentsNumber}}</span>期，每期新台幣<span class="p1-2">{{editedItem.vendor.creditPriceMonth}}</span>元整(含稅)，繳款日依甲方提供之繳款通知所載。
          </p><!--p1-->
          <span class="list-1"></span>

          <div class="grayBox">
            <div class="sign">
              乙方：
              <img class="box" :src="signImageSrc('signImage1')"/>
              <span class="ps">(正楷簽名)</span><br/>
              <span class="id">身分證字號：<div class="con8">{{editedItem.customer.memberId}}</div></span>
            </div>
            <div class="sign">
               乙方連帶保證人：
               <img class="box" style="top: 60px;" :src="signImageSrc('signImage3')"/>
               <span class="ps">(正楷簽名)</span><br/>
              <span class="id">身分證字號：<div class="con9">{{editedItem.jointGuarantor.memberId}}</div></span>
            </div>
          </div><!--grayBox-->
          <div class="date">
            中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;華&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;國<span class="d">105</span>年<span class="d">12</span>月<span class="d">31</span>日
          </div>
        </div><!--page2-->
        <div class="page page3">
          <h4>中&nbsp;&nbsp;古&nbsp;&nbsp;機&nbsp;&nbsp;車&nbsp;&nbsp;買&nbsp;&nbsp;賣&nbsp;&nbsp;契&nbsp;&nbsp;約</h4>
          <table class="table1">
            <tr>
              <td width="230px">
                <span class="tdTit">甲方(即出賣人)：</span>
                <div class="con1">{{editedItem.customer.name}}</div>
              </td>
              <td width="200px">
                <span class="tdTit">身分證字號：</span>
                <div class="con2">{{editedItem.customer.memberId}}</div>
              </td>
              <td>
                <span class="tdTit">地址：</span>
                <div class="con3">{{editedItem.customer.home.residenceAddress}}</div>
              </td>
            </tr>
          </table><!--table1-->
          <div class="checkDiv checkDiv1">
            <span class="checkbox">
              <input type="checkbox" disabled="" checked="" id="checkbox-1">
              <label for="checkbox-1">
                <!-- <img src="checked.png"> -->
              </label>
            </span>
            曾發生重大事故，受損狀況說明
          </div>
          <div class="checkDiv checkDiv2">
            <span class="checkbox">
              <input type="checkbox" disabled="" checked="" id="checkbox-1">
              <label for="checkbox-1">
                <!-- <img src="checked.png"> -->
              </label>
            </span>
            不知
          </div>
          <span class="p1-1"></span>
          <div class="checkDiv checkDiv3">
            <span class="checkbox">
              <input type="checkbox" disabled="" checked="" id="checkbox-1">
              <label for="checkbox-1">
                <!-- <img src="checked.png"> -->
              </label>
            </span>
            為泡水車
          </div>
          <div class="checkDiv checkDiv4">
            <span class="checkbox">
              <input type="checkbox" disabled="" checked="" id="checkbox-1">
              <label for="checkbox-1">
                <!-- <img src="checked.png"> -->
              </label>
            </span>
            全部泡水
          </div>
          <div class="checkDiv checkDiv5">
            <span class="checkbox">
              <input type="checkbox" disabled="" checked="" id="checkbox-1">
              <label for="checkbox-1">
                <!-- <img src="checked.png"> -->
              </label>
            </span>
            一半泡水
          </div>
          <div class="checkDiv checkDiv6">
            <span class="checkbox">
              <input type="checkbox" disabled="" checked="" id="checkbox-1">
              <label for="checkbox-1">
                <!-- <img src="checked.png"> -->
              </label>
            </span>
            不知
          </div>
          <span class="p2-1"></span>
          <span class="p4-1"></span>
          <span class="p4-2"></span>
          <div class="id">{{editedItem.customer.memberId}}</div>

          <div class="date">
            中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;華&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;國<span class="d">105</span>年<span class="d">12</span>月<span class="d">31</span>日
          </div>
          <div class="btBox">
            <span class="btBox-1">{{editedItem.vendor.totalCreditPrice}}</span>
            <div class="date2">
              中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;華&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;國<span class="d">105</span>年<span class="d">12</span>月<span class="d">31</span>日
            </div>
          </div><!--btBox-->
        </div><!--page3-->
      </div><!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EntrepreneurTemplateView",
  props: {
    item: Object
  },
  data() {
    return {
      checkedImage: require('../../assets/images/checked.png'),
    }
  },
  computed: {
    editedItem() {
      return this.item;
    },
  },
  methods: {
    signImageSrc(itemPath){
      let source = null;
      if (itemPath === 'signImage1'){
        if (this.editedItem.signImage1) {
          source = this.editedItem.signImage1;
        } else if(this.editedItem.signimage1Url) {
          source = this.editedItem.signimage1Url;
        }
      } else if(itemPath === 'signImage2'){
        if (this.editedItem.signImage2){
          source = this.editedItem.signImage2;
        } else if(this.editedItem.signimage2Url) {
          source = this.editedItem.signimage2Url;
        }
      } else if(itemPath === 'signImage3'){
        if (this.editedItem.signImage3){
          source = this.editedItem.signImage3;
        } else if(this.editedItem.signimage3Url) {
          source = this.editedItem.signimage3Url;
        }
      }
      return source;
    },
  }
}
</script>

<style scoped src="../../assets/css/entrepreneur_template_view.css">
</style>

<style scoped>
.box {
  position: absolute;
  width: 150px;
  height: 38px;
  left: 160px;
  top: 2px;
  background: #ffffff;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/web/EntrepreneurTemplateView.vue